import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { Cover } from '@components/basics/Images/Cover';
import { AccessibleLink } from '@components/main-components/link/AccessibleLink';
import type { FragmentType } from '@graphql/reactQuery';
import { BuyEditionSongDetailsFragmentDoc, getFragment } from '@graphql/reactQuery';
import { webappUriPath } from '@utils/url';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment BuyEditionSongDetails on Release {
    id
    title
    chainId
    samAddress
    gaCoverImage {
      id
      url
    }
    vipCoverImage {
      id
      url
    }
    staticCoverImage {
      id
      url
    }
    coverImage {
      id
      url
    }
    artist {
      id
      webappUri
      name
    }
  }
`);

const GA_TIER = 0;
const VIP_TIER = 1;

export const SongDetails = ({
  data,
  selectedTier,
}: {
  data: FragmentType<BuyEditionSongDetailsFragmentDoc>;
  selectedTier: number | null;
}) => {
  const { title, artist, coverImage, staticCoverImage, gaCoverImage, vipCoverImage } = getFragment(
    BuyEditionSongDetailsFragmentDoc,
    data,
  );

  const coverImageUrl = (() => {
    if (selectedTier === GA_TIER && gaCoverImage?.url) {
      return gaCoverImage.url;
    }
    if (selectedTier === VIP_TIER && vipCoverImage?.url) {
      return vipCoverImage.url;
    }

    return staticCoverImage?.url || coverImage.url;
  })();

  return (
    <div className="flex border-b border-base200 pb-3">
      <Cover alt={title} src={coverImageUrl} size={60} />
      <div className="ml-3 flex flex-col justify-center">
        <AccessibleLink pathnameUri={webappUriPath(artist.webappUri)}>
          <h4 className="font-base text-base-s font-normal text-base800">{artist.name}</h4>
        </AccessibleLink>
        <h3 className="mt-1 font-title text-title-s font-medium text-base800">{title}</h3>
      </div>
    </div>
  );
};
